import React from 'react';
import { ShopIcon } from '../../assets/icons';
import RoleCreatePage from '../RoleManagement/RoleCreatePage';
import { ROLE_CONFIGS } from '../RoleManagement/roleConfig';
import styles from './ShopCreatePage.module.css';

const ShopCreatePage: React.FC = () => (
  <RoleCreatePage config={ROLE_CONFIGS.shop} styles={styles} Icon={ShopIcon} />
);

export default ShopCreatePage;
